<div class="auctions-list"><trading-list :data="mock" v-bind="$attrs"></trading-list></div>